(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_ns-home-single-slideshow"] && !Shopify.designMode) return;
  try {
    const allAccordions = document.querySelectorAll('.js-highlight-accordion');

function closeAllAccordions(thisId) {
  allAccordions.forEach(accordionItem => {
    if(accordionItem.id === thisId) return;

    accordionItem.classList.remove('active');
  });
}

allAccordions.forEach(accordionItem => {
  const accordionHeadline = accordionItem.querySelector('.headline');
  const accordionContent = accordionItem.querySelector('.content');

  accordionHeadline.addEventListener('click', (e) => {
    const thisId = e.target.closest('.js-highlight-accordion').id;

    closeAllAccordions(thisId);

    accordionItem.classList.toggle('active');
  })
});

const swiperHighlights = new Swiper('.js-swiper-highlights', {
  // Optional parameters
  loop: false,
  slidesPerView: 2.3,
  spaceBetween: 16,
  centerInsufficientSlides: true,
  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ns-product-highights-category"] && !Shopify.designMode) return;
  try {
    const allAccordions = document.querySelectorAll('.js-highlight-accordion');

function closeAllAccordions(thisId) {
  allAccordions.forEach(accordionItem => {
    if(accordionItem.id === thisId) return;

    accordionItem.classList.remove('active');
  });
}

allAccordions.forEach(accordionItem => {
  const accordionHeadline = accordionItem.querySelector('.headline');
  const accordionContent = accordionItem.querySelector('.content');

  accordionHeadline.addEventListener('click', (e) => {
    const thisId = e.target.closest('.js-highlight-accordion').id;

    closeAllAccordions(thisId);

    accordionItem.classList.toggle('active');
  })
});

const swiperHighlights = new Swiper('.js-swiper-highlights', {
  // Optional parameters
  loop: false,
  slidesPerView: 2.3,
  spaceBetween: 16,
  centerInsufficientSlides: true,
  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ns-product-media-gallery"] && !Shopify.designMode) return;
  try {
    /**
   * Product swiper
   */
  const swiperProduct = new Swiper('.js-swiper-product', {
    // Optional parameters
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: false,
    centerInsufficientSlides: false,
    pagination: {
      el: '.swiper-pagination-prod',
    },
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-prod-next',
      prevEl: '.swiper-button-prod-prev',
    },
    breakpoints: {
      450: {
        slidesPerView: 1.5,
      },
      768: {
        slidesPerView: 2.3,
      },
    },
  });
  } catch(e) { console.error(e); }
})();

})();
